/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/account-info-2.css';
import { Button, Segment, Form, Input, Header, Select, Checkbox, List, Icon, Grid, Progress} from 'semantic-ui-react';
import { Link, Redirect} from 'react-router-dom';
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";

class AccountInfo2 extends Component {
  constructor() {
    super();
    this.state = {
      toNextPage: false,
      incoterms: '',
      freightForwarders: [],
      freightForwarder: '',
      carriers: [],
      carrier: '',
      brokerType: '',
      individual: false,
      brokers: [],
      brokers2: [],
      broker: '',
      brokerEmail: '',
    }
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value }, console.log(this.state))

  getCookieValue = (name) => {
    var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

  handleRadioChange = (e, { value }) => {

  this.setState({ brokerType: value }, console.log(this.state.brokerType))

  return value === "independent" ? this.setState({individual: true}, console.log(this.state.individual)) : this.setState({ individual: false }, console.log(this.state.individual))

}


  handleSubmit = () => {
    const { incoterms, brokerType, brokers, broker, brokerEmail, individual} = this.state
    const newBroker = {broker, brokerEmail, brokerType}
    const newBrokerAPI = {broker, brokerEmail, individual}
    if (this.state.broker.length > 0) {
      this.setState({ incoterms, brokerType, brokers: [...this.state.brokers, newBroker], brokers2: [...this.state.brokers2, newBrokerAPI], broker: '', brokerEmail: '', brokerType: ''})
    } 
    
    if (this.state.freightForwarder.length > 0) {
      this.setState({ freightForwarders: [...this.state.freightForwarders, this.state.freightForwarder], freightForwarder: '' })
    } 
    
    if (this.state.carrier.length > 0) {
      this.setState({ carriers: [...this.state.carriers, this.state.carrier], carrier: '' })
    }
  }

  onFinalSubmit = () => {
    API.shippingInfo(
      this.getCookieValue('kxCustomerToken'),
      this.state.incoterms,
      this.state.freightForwarders,
      this.state.carriers,
      this.state.brokers2
    ).then(response => {
      return response.json()
    }).then(responseData => {
      console.log(responseData);
    }).then(
      this.setState({ toNextPage: true })
    ).catch(err => console.log('ERROR:', err))

    // this.props.storeProgressData("ai2", "item progress-green")
  }

  handleSkip = () => {
    this.props.storeProgressData("ai2", "piece progress-gray")
  }

  removeBroker = (item) => this.setState({ brokers: this.state.brokers.filter(elem => elem !== item) })
  removeCarrier = (itm) => this.setState({ carriers: this.state.carriers.filter(elm => elm !== itm) })
  removeFF = (it) => this.setState({ freightForwarders: this.state.freightForwarders.filter(el => el !== it) })



  render() {

    const options = [
      { key: 'DAP', text: 'DAP - Deliver At Place (named place of destination)', value: 'DAP' },
      { key: 'EXW', text: 'EXW – Ex Works (named place of delivery)', value: 'EXW' },
      { key: 'FCA', text: 'FCA – Free Carrier (named place of delivery)', value: 'FCA' },
      { key: 'FAS', text: 'FAS – Free Alongside Ship (named port of shipment)', value: 'FAS' },
      { key: 'FOB', text: 'FOB – Free on Board (named port of shipment)', value: 'FOB' },
      { key: 'CFR', text: 'CFR – Cost and Freight (named port of destination)', value: 'CFR' },
      { key: 'CIF', text: 'CIF – Cost, Insurance & Freight (named port of destination)', value: 'CIF' },
      { key: 'DAT', text: 'DAT – Delivered At Terminal (named terminal at port or place of destination)', value: 'DAT' },
      { key: 'CPT', text: 'CPT – Carriage Paid To (named place of destination)', value: 'CPT' },
      { key: 'CIP', text: 'CIP – Carriage and Insurance Paid to (named place of destination)', value: 'CIP' },
      { key: 'DDP', text: 'DDP – Delivered Duty Paid (named place of destination)', value: 'DDP' },
    ]

    const { incoterms, freightForwarder, carrier, broker, brokerType, brokerEmail } = this.state

    if (this.state.toNextPage === true) {
      this.props.storeProgressData("ai2", "piece progress-green")
			return <Redirect to='/accountInfo3' /> 
    }

    return (
      <div>
        <ProgressBar progressData={this.props.progressData}/>
        <h2 className="ai2h2">Account Information</h2>
        <Segment padded='very' raised className="ai2-segment-container">
          <Form>
            <Header as='h1'>Shipping Information</Header>
            <Form.Field>
              <label className="account-info-2-label">INCOTERMS</label>
              <br />
              <Select onChange={this.handleChange.bind(this)} name="incoterms" value={incoterms}  className="ai2DAPSelect" options={options} placeholder={options[0].text} />
            </Form.Field>
            <Form.Field>
              <label className="account-info-2-label">FREIGHT FORWARDERS</label>
              <Input name="freightForwarder" value={freightForwarder} className="account-ino-2-input" placeholder='Freight Forwarder 1' onChange={this.handleChange.bind(this)} />
              <br />
              <br />
              <Icon name="add" color="blue" onClick={this.handleSubmit.bind(this)} />
              <Link to='#' className="addFFCB" onClick={this.handleSubmit.bind(this)}> Add More</Link>
            </Form.Field>
            <List>
              {this.state.freightForwarders.map((x, i) => {
                return <List.Item key={i} as="h5"><Icon name="remove" onClick={() => this.removeFF(x)} /> Forwarder: {x}</List.Item>
              })}
            </List>
            <Form.Field>
              <label className="account-info-2-label">CARRIERS</label>
              <Input name="carrier" value={carrier} className="account-ino-2-input" placeholder='Carrier 1' onChange={this.handleChange.bind(this)} />
              <br />
              <br />
              <Icon name="add" color="blue" onClick={this.handleSubmit.bind(this)} />
              <Link to='#' className="addFFCB" onClick={this.handleSubmit.bind(this)}> Add More</Link>
              <List>
                {this.state.carriers.map((a, index) => {
                  return <List.Item key={index} as="h5"><Icon name="remove" onClick={() => this.removeCarrier(a)} /> Carrier: {a}</List.Item>
                })}
              </List>
            </Form.Field>
            <Form.Field>
              <br />
              <label className="ai2-broker-label">BROKERS</label>
              <Input name="broker" value={broker} className="account-ino-2-input" placeholder='Joe the Broker 1' onChange={this.handleChange.bind(this)} />
              <Input name="brokerEmail" value={brokerEmail} className="account-ino-2-input" placeholder='Email of Broker' onChange={this.handleChange.bind(this)} />

              <Form.Group style={{float: 'right'}}>

                    <Form.Radio
                      label='Independent'
                      value='independent'
                      checked={brokerType === 'independent'}
                      onChange={this.handleRadioChange}
                      width={16}
                    />

                    <Form.Radio
                      label='Brokerage'
                      value='brokerage'
                      checked={brokerType === 'brokerage'}
                      onChange={this.handleRadioChange}
                      width={16}
                    />

              </Form.Group>

              <Icon name="add" color="blue" onClick={this.handleSubmit.bind(this)} />
              <Link to='#' className="addFFCB" onClick={this.handleSubmit.bind(this)}> Add More</Link>
            </Form.Field>
            <List>
              {this.state.brokers.map((b, ind) => {
                return <li key={ind} as="h5"><Icon name="remove" onClick={() => this.removeBroker(b)} /> Broker: {b.broker}, Type: {b.brokerType} </li>
              })}
            </List>
            <br />
            <br />
            <div className="ai2-buttonRow">
              <Link to='/accountInfo1'>
                <Button type='submit' className="account-info-2-cancel">CANCEL</Button>
              </Link>
              <Link to='./accountInfo3'>
                <Button type='submit' className="account-info-2-skip" onClick={this.handleSkip}>SKIP THIS</Button>
              </Link>
              {/* <Link to='./accountInfo3'> */}
                <Button type='submit' className="account-info-2-save" color="twitter" onClick={this.onFinalSubmit}>SAVE & NEXT</Button>
              {/* </Link> */}
            </div>
          </Form>
        </Segment>
      </div>
    );
  }
}

export default AccountInfo2;